import { Textarea, type TextareaProps } from '@frontend/legacy-components';

import type { SupportFormFieldName } from '../types';
import { SupportFormControl } from './SupportFormControl';
import type { SupportFormControlProps } from './SupportFormControl';
import { SupportFormField } from './SupportFormField';

export type SupportFormTextareaFieldProps<
  FieldName extends SupportFormFieldName,
> = Omit<SupportFormControlProps<FieldName>, 'fieldProps' | 'isRequired'> & {
  textareaProps?: TextareaProps;
};

export const SupportFormTextareaField = <
  FieldName extends SupportFormFieldName,
>({
  name,
  textareaProps = {},
  ...restProps
}: SupportFormTextareaFieldProps<FieldName>) => {
  const { isRequired } = textareaProps;

  return (
    <SupportFormField name={name}>
      {(fieldProps) => {
        const { field } = fieldProps;

        return (
          <SupportFormControl
            {...restProps}
            fieldProps={fieldProps}
            name={name}
            isRequired={isRequired}
          >
            <Textarea {...field} {...textareaProps} />
          </SupportFormControl>
        );
      }}
    </SupportFormField>
  );
};
